import React from "react";
import { ReactComponent as ClockIcon } from "@assets/icons/clock.svg";

type DashboardWaitingEmployerDetailsProps = {
  userData: any;
};

const DashboardWaitingEmployerDetails: React.FC<
  DashboardWaitingEmployerDetailsProps
> = ({ userData }) => {
  return (
    <div className="p-4">
      <div className="border bg-pn_white border-pn_gray-200 rounded-2xl gap-y-4 p-6 flex flex-col">
        <div className="bg-pn_paper-3 rounded-full w-10 h-10 flex items-center justify-center">
          <ClockIcon />
        </div>
        <div className="flex flex-col gap-y-2">
          <span className="text-pn-headline-emphasis text-pn_gray-950">
            Waiting for Employer confirmation
          </span>
          <span className="text-pn-callout-regular text-pn_gray-600">
            {userData?.first_name}, we are waiting for your employer to confirm
            their details. Once completed, we will get back to you.
          </span>
        </div>
      </div>
    </div>
  );
};
export default DashboardWaitingEmployerDetails;
